/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskBoxResponse } from './TaskBoxResponse';
import {
    TaskBoxResponseFromJSON,
    TaskBoxResponseFromJSONTyped,
    TaskBoxResponseToJSON,
    TaskBoxResponseToJSONTyped,
} from './TaskBoxResponse';
import type { TaskImportFileResponse } from './TaskImportFileResponse';
import {
    TaskImportFileResponseFromJSON,
    TaskImportFileResponseFromJSONTyped,
    TaskImportFileResponseToJSON,
    TaskImportFileResponseToJSONTyped,
} from './TaskImportFileResponse';
import type { TaskPersonResponse } from './TaskPersonResponse';
import {
    TaskPersonResponseFromJSON,
    TaskPersonResponseFromJSONTyped,
    TaskPersonResponseToJSON,
    TaskPersonResponseToJSONTyped,
} from './TaskPersonResponse';
import type { TaskNoteResponse } from './TaskNoteResponse';
import {
    TaskNoteResponseFromJSON,
    TaskNoteResponseFromJSONTyped,
    TaskNoteResponseToJSON,
    TaskNoteResponseToJSONTyped,
} from './TaskNoteResponse';

/**
 * 
 * @export
 * @interface TaskResponse
 */
export interface TaskResponse {
    /**
     * 
     * @type {number}
     * @memberof TaskResponse
     */
    taskId?: number;
    /**
     * 
     * @type {string}
     * @memberof TaskResponse
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskResponse
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskResponse
     */
    taskPriorityType?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskResponse
     */
    patientNoteType?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskResponse
     */
    originalExpression?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskResponse
     */
    resultDate?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskResponse
     */
    taskStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskResponse
     */
    showDateTime?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TaskResponse
     */
    hasAlert?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TaskResponse
     */
    isPrivate?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TaskResponse
     */
    taskBoxId?: string;
    /**
     * 
     * @type {TaskBoxResponse}
     * @memberof TaskResponse
     */
    taskBox?: TaskBoxResponse;
    /**
     * 
     * @type {TaskPersonResponse}
     * @memberof TaskResponse
     */
    pwrPatient?: TaskPersonResponse;
    /**
     * 
     * @type {TaskPersonResponse}
     * @memberof TaskResponse
     */
    pwrTaskCreator?: TaskPersonResponse;
    /**
     * 
     * @type {TaskPersonResponse}
     * @memberof TaskResponse
     */
    pwrTaskStatusChanger?: TaskPersonResponse;
    /**
     * 
     * @type {Array<TaskNoteResponse>}
     * @memberof TaskResponse
     */
    taskNotes?: Array<TaskNoteResponse>;
    /**
     * 
     * @type {TaskImportFileResponse}
     * @memberof TaskResponse
     */
    taskImportFile?: TaskImportFileResponse;
}

/**
 * Check if a given object implements the TaskResponse interface.
 */
export function instanceOfTaskResponse(value: object): value is TaskResponse {
    return true;
}

export function TaskResponseFromJSON(json: any): TaskResponse {
    return TaskResponseFromJSONTyped(json, false);
}

export function TaskResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'taskId': json['taskId'] == null ? undefined : json['taskId'],
        'updated': json['updated'] == null ? undefined : json['updated'],
        'created': json['created'] == null ? undefined : json['created'],
        'taskPriorityType': json['taskPriorityType'] == null ? undefined : json['taskPriorityType'],
        'patientNoteType': json['patientNoteType'] == null ? undefined : json['patientNoteType'],
        'originalExpression': json['originalExpression'] == null ? undefined : json['originalExpression'],
        'resultDate': json['resultDate'] == null ? undefined : json['resultDate'],
        'taskStatus': json['taskStatus'] == null ? undefined : json['taskStatus'],
        'showDateTime': json['showDateTime'] == null ? undefined : json['showDateTime'],
        'hasAlert': json['hasAlert'] == null ? undefined : json['hasAlert'],
        'isPrivate': json['isPrivate'] == null ? undefined : json['isPrivate'],
        'taskBoxId': json['taskBoxId'] == null ? undefined : json['taskBoxId'],
        'taskBox': json['taskBox'] == null ? undefined : TaskBoxResponseFromJSON(json['taskBox']),
        'pwrPatient': json['pwrPatient'] == null ? undefined : TaskPersonResponseFromJSON(json['pwrPatient']),
        'pwrTaskCreator': json['pwrTaskCreator'] == null ? undefined : TaskPersonResponseFromJSON(json['pwrTaskCreator']),
        'pwrTaskStatusChanger': json['pwrTaskStatusChanger'] == null ? undefined : TaskPersonResponseFromJSON(json['pwrTaskStatusChanger']),
        'taskNotes': json['taskNotes'] == null ? undefined : ((json['taskNotes'] as Array<any>).map(TaskNoteResponseFromJSON)),
        'taskImportFile': json['taskImportFile'] == null ? undefined : TaskImportFileResponseFromJSON(json['taskImportFile']),
    };
}

export function TaskResponseToJSON(json: any): TaskResponse {
    return TaskResponseToJSONTyped(json, false);
}

export function TaskResponseToJSONTyped(value?: TaskResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'taskId': value['taskId'],
        'updated': value['updated'],
        'created': value['created'],
        'taskPriorityType': value['taskPriorityType'],
        'patientNoteType': value['patientNoteType'],
        'originalExpression': value['originalExpression'],
        'resultDate': value['resultDate'],
        'taskStatus': value['taskStatus'],
        'showDateTime': value['showDateTime'],
        'hasAlert': value['hasAlert'],
        'isPrivate': value['isPrivate'],
        'taskBoxId': value['taskBoxId'],
        'taskBox': TaskBoxResponseToJSON(value['taskBox']),
        'pwrPatient': TaskPersonResponseToJSON(value['pwrPatient']),
        'pwrTaskCreator': TaskPersonResponseToJSON(value['pwrTaskCreator']),
        'pwrTaskStatusChanger': TaskPersonResponseToJSON(value['pwrTaskStatusChanger']),
        'taskNotes': value['taskNotes'] == null ? undefined : ((value['taskNotes'] as Array<any>).map(TaskNoteResponseToJSON)),
        'taskImportFile': TaskImportFileResponseToJSON(value['taskImportFile']),
    };
}

